import { render, staticRenderFns } from "./WidgetTimeChooser.vue?vue&type=template&id=1ff23fd8&scoped=true"
import script from "./WidgetTimeChooser.vue?vue&type=script&lang=ts"
export * from "./WidgetTimeChooser.vue?vue&type=script&lang=ts"
import style0 from "./WidgetTimeChooser.vue?vue&type=style&index=0&id=1ff23fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff23fd8",
  null
  
)

export default component.exports